import * as ActionTypes from "../constants/ActionTypes";

// **************************************************************************************************************
export const collapsibleContentReducer = (state = {}, action) => {

    switch (action.type) {

        case ActionTypes.COLLAPSIBLE_CONTENT_TOGGLED:

            const oldToggleState = state[action.toggleId] ? state[action.toggleId] : false

            return Object.assign({}, state, {[action.toggleId]: !oldToggleState})

        case ActionTypes.COLLAPSIBLE_OPEN_CONTENT:

            return Object.assign({}, state, {[action.toggleId]: true})

        case ActionTypes.COLLAPSIBLE_CLOSE_CONTENT:

            return Object.assign({}, state, {[action.toggleId]: false})

        default:
            return state

    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/Collapsibles.js
 **/